export interface ClientUploadConfig {
  maxFiles: number;
  allowedExtensions: string[];
}

const ALLOWED_EXTENSIONS = ['.sav', '.csv', '.xlsx', '.xls'];

const DEFAULT_UPLOAD_CONFIG: ClientUploadConfig = {
  maxFiles: 2,
  allowedExtensions: ALLOWED_EXTENSIONS,
};

const CLIENT_UPLOAD_CONFIG: Record<string, ClientUploadConfig> = {
  /** Add client if they required upload config other than default as shown below
   * "verizonconsumer": {
   *     maxFiles: 2,
   *     allowedExtensions: ALLOWED_EXTENSIONS,
   *   }
   */
};

export const getClientUploadConfig = (clientName?: string): ClientUploadConfig =>
  (clientName && CLIENT_UPLOAD_CONFIG[clientName]) || DEFAULT_UPLOAD_CONFIG;
